/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React, { useEffect, useState, memo } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import API from 'api';
import Asset from 'models/business/Asset';
import Ad from 'models/business/Ad';
import Market from 'models/business/Market';
import TopUpCard from 'components/Common/TopUpCard';
import RemindDashboard from './RemindDashboard';
import TutorialDashboard from './TutorialDashboard';
import Styles from './index.module.css';

function OrangeButton({
  onClick,
  children,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={Styles.orangeButton}
    >
      {children}
    </button>
  );
}

OrangeButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node,
};

OrangeButton.defaultProps = {
  onClick: () => {},
  children: null,
};

function TopUp() {
  const [markets, setMarkets] = useState([]);
  const [ads, setAds] = useState([]);
  const history = useHistory();
  const [sumCostGoogleEffect, setSumCostGoogleEffect] = useState(0);
  const [sumCostFacebookEffect, setSumCostFacebookEffect] = useState(0);
  const fetchMarketAssets = async (id) => {
    const result = await API.mall.getMallAssets(id);
    if (result.error) {
      alert(result.error.errorMsg);
      return null;
    }

    return (result.resultData || []).map((a) => new Asset(a))[0];
  };

  const fetchMarkets = async () => {
    const result = await API.mall.getMallList();
    if (result.error) {
      alert(result.error.errorMsg);
      return [[], result.error];
    }
    // eslint-disable-next-line max-len
    return [(result.resultData || []).map((ad) => new Market(ad))];
  };

  const fetchAds = async () => {
    // const result = await API.ad.postAdList();
    const result = await API.ad.postAdList2();
    if (result.error) {
      alert(result.error.errorMsg);
      return [[], result.error];
    }
    return [(result.resultData || []).map((ad) => new Ad(ad))];
  };

  const load = async () => {
    const [newMarkets, marketError] = await fetchMarkets();
    const marketLookup = newMarkets.reduce((ms, m) => ({ ...ms, [m.id]: m }), {});
    const [newAds, adError] = await fetchAds();
    const marketAssetLookup = [];
    for (let i = 0; i < newMarkets.length; i += 1) {
      // eslint-disable-next-line no-await-in-loop
      const asset = await fetchMarketAssets(newMarkets[i].id);
      if (asset) marketAssetLookup[newMarkets[i].id] = asset;
    }
    newAds.forEach((ad) => {
      ad.injectMarket(marketLookup[ad.marketId]);
      // eslint-disable-next-line no-param-reassign
      ad.marketContentFeedId = marketAssetLookup[ad.marketId]?.id || '';
    });
    setMarkets(newMarkets);
    setAds(newAds);
    return {
      markets: newMarkets,
      ads: newAds,
      error: marketError || adError,
    };
  };

  useEffect(async () => {
    const userInfo = await API.auth.getUserInfo();
    if (!userInfo.error) {
      localStorage.setItem('amounts', JSON.stringify({ google: userInfo.resultData.googleAmount, facebook: userInfo.resultData.facebookAmount }));
    }
    const resultGoogleEffect = await API.ad.getGooglePerformanceData((new Date('October 1, 2021 08:00:00')).toISOString(), (new Date()).toISOString());
    setSumCostGoogleEffect(resultGoogleEffect.resultData.reduce((accumulator, item) => accumulator + +item.cost, 0));
    const resultFacebookEffect = await API.ad.getFacebookPerformanceData((new Date('October 1, 2021 08:00:00')).toISOString(), (new Date()).toISOString());
    setSumCostFacebookEffect(resultFacebookEffect.resultData.reduce((accumulator, item) => accumulator + +item.cost, 0));
    load().then(({ markets: newMarkets, error }) => {
      if (!error && !newMarkets.length) {
        alert('請新增賣場再繼續');
        history.push('/MarketSetting');
      }
    });
  }, []);

  return (
    <div
      className={Styles.container}
    >
      <div
        className={Styles.leftBoard}
      />
      <div
        className={Styles.midBoard}
      >

        <div
          className={Styles.midBoardItem}
        >
          <div
            className={Styles.titleText}
          >
            儲值狀態
          </div>
          <TopUpCard
            ads={ads}
            sumCostGoogleEffect={sumCostGoogleEffect}
            sumCostFacebookEffect={sumCostFacebookEffect}
          />
        </div>
        <div
          className={Styles.midBoardItem}
        >
          <div
            className={Styles.titleText}
          >
            欣新網貼心提醒
          </div>
          <RemindDashboard />
        </div>
        <div
          className={Styles.midBoardItem}
        >
          <div
            className={Styles.titleText}
          >
            儲值教學
          </div>
          <TutorialDashboard />
        </div>
        <a
          href="https://www.hhgalaxy.com.tw/qa/88#1" rel="noopener noreferrer nofollow" target="_blank"
          className={Styles.midBoardButton}
        >
          <OrangeButton>查看儲值教學</OrangeButton>
        </a>
      </div>
      <div className={Styles.rightBoard} />
    </div>
  );
}

export default memo(TopUp);
